export const openTermsHtml = () => {};
